import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Landing from './components/Landing';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import { ConfirmProvider } from './context/ConfirmContext';
import { ThemeProvider } from './context/ThemeContext';
import ThemeDemo from './components/theme/ThemeDemo';

function App() {
  return (
    <ThemeProvider>
      <ConfirmProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/theme-demo" element={<ThemeDemo />} />
            <Route path="/dashboard" element={<Layout />} />
            <Route path="/LiveMonitor" element={<Layout />} />
            <Route path="/pc-info" element={<Layout />} />
            <Route path="/masters" element={<Layout />} />
            <Route path="/masters/quick-messages" element={<Layout />} />
            <Route path="/masters/departments" element={<Layout />} />
            <Route path="/masters/rooms" element={<Layout />} />
            <Route path="/masters/blocks" element={<Layout />} />
            <Route path="/reports/app-usage" element={<Layout />} />
            <Route path="/reports/idle-time" element={<Layout />} />
          </Routes>
        </Router>
      </ConfirmProvider>
    </ThemeProvider>
  );
}

export default App;
